// Static schedule, class metadata and pure availability logic for the Timetable.
// This module holds the business rules that must stay intact:
//  - Baby Shark never shows a live space count (Saturday → waitlist, else → contact)
//  - Sharks (school-age) route to "Contact us" (Sat afternoon → "spaces-contact")
//  - Saturday-morning Baby & Pre-School: spaces → contact us, full → join waiting list

export const BOOK_URL = "https://portal.pivot1st.co.uk/book/2/class";

// Colour per class name (the Sharks family shares orange shades to read as a group)
export const CLASS_META = {
  "Baby Shark": "#0EA5E9",
  Guppies: "#22C55E",
  "Small Fry": "#06B6D4",
  Tetra: "#3B82F6",
  Tiny: "#A855F7",
  Tots: "#F59E0B",
  Urchins: "#10B981",
  "Sharks 1": "#FB923C",
  "Sharks 2": "#F97316",
  "Sharks 3": "#EA580C",
  "Adult Class": "#0A2540",
  "Adult Social": "#14B8A6",
  "Adult Social Swim": "#14B8A6",
  "Happy Bubbles": "#EC4899",
  "Happy Bumps": "#EC4899",
  "Little Tiddlers": "#8B5CF6",
  "Little Tiddler Social": "#8B5CF6",
};

export const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

// [class, day, time, category]
const SESSIONS = [
  ["Adult Class", "Tuesday", "19:00", "Adult"],
  ["Adult Class", "Thursday", "11:30", "Adult"],
  ["Adult Social", "Tuesday", "08:30", "Adult Social Swim"],
  ["Adult Social", "Friday", "14:00", "Adult Social Swim"],
  ["Baby Shark", "Monday", "13:00", "Baby Pre School"],
  ["Baby Shark", "Tuesday", "10:30", "Baby Pre School"],
  ["Baby Shark", "Wednesday", "11:00", "Baby Pre School"],
  ["Baby Shark", "Thursday", "10:30", "Baby Pre School"],
  ["Baby Shark", "Friday", "12:30", "Baby Pre School"],
  ["Baby Shark", "Friday", "13:30", "Baby Pre School"],
  ["Baby Shark", "Saturday", "12:00", "Baby Pre School"],
  ["Guppies", "Monday", "10:00", "Baby Pre School"],
  ["Guppies", "Tuesday", "11:30", "Baby Pre School"],
  ["Guppies", "Wednesday", "12:00", "Baby Pre School"],
  ["Guppies", "Friday", "10:30", "Baby Pre School"],
  ["Guppies", "Saturday", "09:30", "Baby Pre School"],
  ["Guppies", "Sunday", "13:30", "Baby Pre School"],
  ["Guppies", "Sunday", "15:00", "Baby Pre School"],
  ["Happy Bubbles", "Monday", "13:00", "Aqua Natal"],
  ["Little Tiddlers", "Monday", "14:00", "Adult & Baby Social Swim"],
  ["Sharks 1", "Monday", "16:00", "Independent"],
  ["Sharks 1", "Monday", "16:30", "Independent"],
  ["Sharks 1", "Monday", "17:00", "Independent"],
  ["Sharks 1", "Monday", "17:30", "Independent"],
  ["Sharks 1", "Tuesday", "16:00", "Independent"],
  ["Sharks 1", "Tuesday", "16:30", "Independent"],
  ["Sharks 1", "Wednesday", "16:00", "Independent"],
  ["Sharks 1", "Wednesday", "16:30", "Independent"],
  ["Sharks 1", "Wednesday", "17:00", "Independent"],
  ["Sharks 1", "Thursday", "16:00", "Independent"],
  ["Sharks 1", "Thursday", "16:30", "Independent"],
  ["Sharks 1", "Thursday", "17:00", "Independent"],
  ["Sharks 1", "Thursday", "17:30", "Independent"],
  ["Sharks 1", "Friday", "16:00", "Independent"],
  ["Sharks 1", "Friday", "16:30", "Independent"],
  ["Sharks 1", "Friday", "17:00", "Independent"],
  ["Sharks 1", "Saturday", "13:00", "Independent"],
  ["Sharks 1", "Saturday", "13:30", "Independent"],
  ["Sharks 1", "Saturday", "14:00", "Independent"],
  ["Sharks 1", "Sunday", "09:30", "Independent"],
  ["Sharks 1", "Sunday", "10:30", "Independent"],
  ["Sharks 1", "Sunday", "11:00", "Independent"],
  ["Sharks 1", "Sunday", "12:00", "Independent"],
  ["Sharks 2", "Monday", "18:00", "Independent"],
  ["Sharks 2", "Monday", "18:30", "Independent"],
  ["Sharks 2", "Tuesday", "17:00", "Independent"],
  ["Sharks 2", "Tuesday", "17:30", "Independent"],
  ["Sharks 2", "Wednesday", "17:30", "Independent"],
  ["Sharks 2", "Wednesday", "18:00", "Independent"],
  ["Sharks 2", "Wednesday", "18:30", "Independent"],
  ["Sharks 2", "Thursday", "18:00", "Independent"],
  ["Sharks 2", "Thursday", "18:30", "Independent"],
  ["Sharks 2", "Friday", "17:30", "Independent"],
  ["Sharks 2", "Friday", "18:00", "Independent"],
  ["Sharks 2", "Saturday", "12:30", "Independent"],
  ["Sharks 2", "Saturday", "14:30", "Independent"],
  ["Sharks 2", "Saturday", "15:00", "Independent"],
  ["Sharks 2", "Sunday", "10:00", "Independent"],
  ["Sharks 2", "Sunday", "11:30", "Independent"],
  ["Sharks 3", "Monday", "19:00", "Independent"],
  ["Sharks 3", "Tuesday", "18:00", "Independent"],
  ["Sharks 3", "Tuesday", "18:30", "Independent"],
  ["Sharks 3", "Wednesday", "19:00", "Independent"],
  ["Sharks 3", "Thursday", "19:00", "Independent"],
  ["Sharks 3", "Friday", "18:30", "Independent"],
  ["Sharks 3", "Saturday", "15:30", "Independent"],
  ["Sharks 3", "Sunday", "09:00", "Independent"],
  ["Small Fry", "Tuesday", "09:30", "Baby Pre School"],
  ["Small Fry", "Wednesday", "11:30", "Baby Pre School"],
  ["Small Fry", "Friday", "13:00", "Baby Pre School"],
  ["Small Fry", "Sunday", "15:30", "Baby Pre School"],
  ["Tetra", "Monday", "09:30", "Baby Pre School"],
  ["Tetra", "Monday", "10:30", "Baby Pre School"],
  ["Tetra", "Tuesday", "11:00", "Baby Pre School"],
  ["Tetra", "Wednesday", "10:00", "Baby Pre School"],
  ["Tetra", "Thursday", "10:00", "Baby Pre School"],
  ["Tetra", "Friday", "09:30", "Baby Pre School"],
  ["Tetra", "Friday", "12:00", "Baby Pre School"],
  ["Tetra", "Saturday", "08:30", "Baby Pre School"],
  ["Tetra", "Saturday", "11:30", "Baby Pre School"],
  ["Tetra", "Sunday", "12:30", "Baby Pre School"],
  ["Tetra", "Sunday", "14:30", "Baby Pre School"],
  ["Tiny", "Monday", "11:00", "Baby Pre School"],
  ["Tiny", "Tuesday", "10:00", "Baby Pre School"],
  ["Tiny", "Wednesday", "10:30", "Baby Pre School"],
  ["Tiny", "Friday", "10:00", "Baby Pre School"],
  ["Tiny", "Friday", "11:00", "Baby Pre School"],
  ["Tiny", "Saturday", "10:00", "Baby Pre School"],
  ["Tiny", "Saturday", "10:30", "Baby Pre School"],
  ["Tiny", "Sunday", "13:00", "Baby Pre School"],
  ["Tots", "Monday", "11:30", "Baby Pre School"],
  ["Tots", "Wednesday", "09:30", "Baby Pre School"],
  ["Tots", "Thursday", "11:00", "Baby Pre School"],
  ["Tots", "Friday", "11:30", "Baby Pre School"],
  ["Tots", "Saturday", "09:00", "Baby Pre School"],
  ["Tots", "Saturday", "11:00", "Baby Pre School"],
  ["Tots", "Sunday", "14:00", "Baby Pre School"],
  ["Urchins", "Wednesday", "12:30", "Baby Pre School"],
];

// Filter chip priority order: babies/pre-school first, then Sharks, then adult/social
export const CLASS_PRIORITY = [
  "Tiny", "Tots", "Tetra", "Guppies", "Small Fry", "Urchins", "Baby Shark",
  "Sharks 1", "Sharks 2", "Sharks 3",
  "Adult Class", "Happy Bumps", "Little Tiddler Social", "Adult Social",
];

export const slug = (s) => s.replace(/[^a-zA-Z0-9]+/g, "-").toLowerCase();

const DUR_45 = new Set(["Happy Bubbles", "Little Tiddlers", "Adult Social"]);
const durationOf = (name) => (DUR_45.has(name) ? "45 min" : "30 min");

const toMin = (t) => {
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
};

// Classes count as "one trip" if every selected class has a session
// starting within this many minutes of a shared start time (back-to-back).
const WINDOW_MIN = 60;

export function isBackToBackDay(daySessions, selected) {
  const byClass = {};
  for (const s of daySessions) {
    if (selected.includes(s.cls)) (byClass[s.cls] = byClass[s.cls] || []).push(s.minute);
  }
  // every selected class must run this day
  if (Object.keys(byClass).length !== selected.length) return false;
  const starts = daySessions.filter((s) => selected.includes(s.cls)).map((s) => s.minute);
  // exists a start time where every class has a session within the window
  return starts.some((start) =>
    selected.every((cls) => byClass[cls].some((t) => t >= start && t <= start + WINDOW_MIN))
  );
}

export const STORE_KEY = "ht_timetable_selected";
export const DAYS_STORE_KEY = "ht_timetable_days";

const SAT_MORNING_CUTOFF = 12 * 60 + 30; // 12:30 — Saturday sessions before this are "morning"

// Decide how availability is displayed for a session.
export function computeMode(cls, day, minute, spaces) {
  if (cls === "Baby Shark") {
    // Never show a live space count for Baby Shark
    return day === "Saturday" ? "waitlist" : "contact";
  }
  if (cls.startsWith("Sharks")) {
    // School-age classes route to Contact (we assess the child's swim experience first)
    if (day === "Saturday" && minute >= SAT_MORNING_CUTOFF) return "spaces-contact"; // Sat afternoon Sharks
    return "contact";
  }
  // Baby & Pre-School / Adult / Happy Bumps / Little Tiddler Social (live availability)
  // Saturday morning Baby & Pre-School: spaces → "contact us", full → "join waiting list"
  if (day === "Saturday" && minute < SAT_MORNING_CUTOFF) {
    return spaces != null && spaces <= 0 ? "waitlist" : "spaces-contact";
  }
  return spaces == null ? "book" : "spaces";
}

// Classes not published in the live Pivot feed (kept from the known schedule).
const SUPPLEMENT_STATIC = SESSIONS
  .filter((s) => s[0] === "Baby Shark" || s[0].startsWith("Sharks"))
  .map((s) => ({
    cls: s[0], day: s[1], time: s[2], minute: toMin(s[2]), category: s[3],
    duration: "30 min", spaces: null, capacity: null,
    mode: computeMode(s[0], s[1], toMin(s[2]), null),
  }));

// Used only if the live Pivot feed is unavailable.
export const FALLBACK_SESSIONS = SESSIONS.map((s) => ({
  cls: s[0], day: s[1], time: s[2], minute: toMin(s[2]), category: s[3],
  duration: durationOf(s[0]), spaces: null, capacity: null,
  mode: computeMode(s[0], s[1], toMin(s[2]), null),
}));

// A session counts as "available" — a space you can act on now.
export function hasAvailability(s) {
  if (s.mode === "spaces") return typeof s.spaces === "number" && s.spaces > 0;
  return s.mode === "spaces-contact" || s.mode === "book";
}

export function normalizeLive(liveSessions) {
  const book = liveSessions
    .filter((x) => x.day && x.minuteOfDay != null && x.name !== "Baby Shark" && !String(x.name || "").startsWith("Sharks"))
    .map((x) => {
      const spaces = typeof x.availableSpaces === "number" ? x.availableSpaces : null;
      return {
        cls: x.name,
        day: x.day,
        time: x.time,
        minute: x.minuteOfDay,
        category: x.course,
        duration: x.durationMinutes ? `${x.durationMinutes} min` : "",
        spaces,
        capacity: x.capacity ?? null,
        mode: computeMode(x.name, x.day, x.minuteOfDay, spaces),
      };
    });
  return [...book, ...SUPPLEMENT_STATIC];
}
